import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import Input from '../../layout/input/Input';
import InputSelect from '../../layout/input/InputSelect';
import InputTextArea from '../../layout/input/InputTextArea';
import Panel from '../../layout/panel/Panel';

import AplicacaoEnum from '../../../helper/enumerador/AplicacaoEnum';
import ShoppingBagEnum from '../../../helper/enumerador/ShoppingBagEnum';
import PerfilSistemaEnum from '../../../helper/enumerador/PerfilSistemaEnum';

class Informacao extends AbstractComponent {      
    constructor(props) {
        super(props);              

        this.aplicacaoType = AplicacaoEnum.list();
        this.perfilSistemaType = PerfilSistemaEnum.list();
        this.shoppingBagType = ShoppingBagEnum.list();
    }             

    onChangeTipoAplicacao(e) {        
        this.props.onChange(e);

        if(this.props.form.tipo_aplicacao === '')
            return ;
            
        if(this.props.form.tipo_aplicacao === AplicacaoEnum.COMPARTILHADA.enumName) {            
            this.props.dedicada(false);
            this.props.compartilhada(true);

            return ;
        }

        this.props.compartilhada(false);
        this.props.dedicada(true);
    }    

    render() {
        return(                                                                 
            <Fragment>   
                <Input
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="alias_app"
                    nome="alias_app"
                    maxLength={17}
                    value={this.props.form.alias_app}                    
                    defaultFoco={true}
                    tooltip={"Nome da sua empresa com 17 caracteres para ser exibido no título da versão mobile - Exemplo: " + this.props.form.fantasia.substring(0, 17) }
                    erro={this.props.erroForm.alias_app}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Alias
                </Input> 

                <Panel 
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    title="Informe os dados do index.html"
                >
                    <Input
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        id="title"
                        nome="title"
                        tooltip="Título da aplicação que será exibida na aba do navegador"                        
                        value={this.props.form.title}                        
                        erro={this.props.erroForm.title}                    
                        onChange={e => this.props.onChange(e)}
                    >
                        Title
                    </Input> 

                    <InputTextArea
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        id="keywords"
                        nome="keywords"                                        
                        value={this.props.form.keywords}                        
                        tooltip="Palavras Chaves utilizadas para os mecanismos de busca encontrar sua empresa"
                        erro={this.props.erroForm.keywords}                    
                        onChange={e => this.props.onChange(e)}
                    >
                        Keywords 
                    </InputTextArea> 

                    <InputTextArea
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        id="description"
                        nome="description"                                        
                        value={this.props.form.description}                        
                        tooltip="Descrição da sua empresa para os mecanismos de busca encontrar sua empresa"
                        erro={this.props.erroForm.description}                    
                        onChange={e => this.props.onChange(e)}
                    >
                        Description 
                    </InputTextArea> 
                </Panel>

                <InputSelect
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="tipo_aplicacao"
                    nome="tipo_aplicacao"
                    value={this.props.form.tipo_aplicacao}
                    erro={this.props.erroForm.tipo_aplicacao}
                    options={this.aplicacaoType}
                    onChange={e => this.onChangeTipoAplicacao(e)}
                >
                    Tipo da aplicação
                </InputSelect>                

                <InputSelect
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="perfil_sistema"
                    nome="perfil_sistema"
                    value={this.props.form.perfil_sistema}
                    erro={this.props.erroForm.perfil_sistema}
                    options={this.perfilSistemaType}
                    onChange={e => this.props.onChange(e)}
                >
                    Perfil do sistema
                </InputSelect>

                <InputSelect
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    nome="shopping_bag"
                    value={this.props.form.shopping_bag}
                    erro={this.props.erroForm.shopping_bag}
                    options={this.shoppingBagType}
                    onChange={e => this.props.onChange(e)}
                >
                    Tipo de bagagem
                </InputSelect>                                                      
            </Fragment>            
        )
    }            
}

export default Informacao;